import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconAppGallery, IconApple, IconGooglePlay, IconSmartTv, IconSplay } from "@/components/icons";

import { IconProps } from "@/@types/general";
import { ROUTES } from "@/config/routes.ts";
import TV_APPS_LINKS from "@/data/tv-apps-links.json";
import { useFooterLinks } from "@/hooks/ui/useFooterLinks.ts";
import { cn } from "@/utils/cn";

const FooterMenus = (): JSX.Element => {
  const { t } = useTranslation();
  const footerLinks = useFooterLinks();

  const icons: Record<number, (props: IconProps) => JSX.Element> = {
    0: IconGooglePlay,
    1: IconApple,
    2: IconAppGallery,
    3: IconSmartTv,
  };

  return (
    <div className="flex w-full gap-8">
      <div className="flex w-full max-w-[630px] flex-col justify-evenly gap-8 max-3xl:max-w-[400px] max-lg:max-w-full">
        <div>
          <IconSplay className={"h-[50px] w-auto fill-orange-1"} />
        </div>
        <div className="flex flex-wrap gap-4">
          {TV_APPS_LINKS.map((link) => {
            const IconComponent = icons[link.id];
            return (
              <Link
                key={link.id}
                to={link.url}
                title={link.name}
                target={"_blank"}
                rel={"nofollow"}
                className={cn(
                  "block rounded-[0.313rem] bg-outline px-3 py-[0.625rem] outline outline-1 -outline-offset-1 outline-outline-variant transition-colors hover:bg-[#FFFFFF26] focus:bg-[#FFFFFF26] focus:outline-on-primary",
                  "max-md:flex  max-md:items-center max-md:justify-center",
                )}
              >
                <IconComponent className={"h-[20px] w-auto"} />
              </Link>
            );
          })}
        </div>
      </div>
      <div className={"flex w-full flex-wrap items-start justify-between gap-8 max-lg:hidden"}>
        {footerLinks.map((menu) => {
          return (
            <ul key={menu.id} className={"w-fit space-y-5"}>
              <li>
                <h2 className={"text-sm font-semibold uppercase leading-4"}>
                  {
                    //@ts-ignore
                    t(menu.name)
                  }
                </h2>
              </li>
              <div className="grid w-fit grid-cols-2 gap-x-6 gap-y-4">
                {menu.links.map((link, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={link.link}
                        //@ts-ignore
                        title={t(link.name)}
                        className={"responsive-transition text-nowrap leading-6 text-on-surface hover:text-on-primary"}
                      >
                        {
                          //@ts-ignore
                          t(link.name)
                        }
                      </Link>
                    </li>
                  );
                })}
                {menu.id === 2 ? (
                  <li>
                    <Link
                      to={ROUTES.MAIN.GENRES}
                      className={
                        "responsive-transition uppercase leading-6 text-on-surface underline hover:text-on-primary"
                      }
                    >
                      {t("General.more")}
                    </Link>
                  </li>
                ) : null}
              </div>
            </ul>
          );
        })}
      </div>
    </div>
  );
};

export default FooterMenus;

{
  /* <div className={"flex items-start justify-between max-md:hidden"}>
    {footerLinks.map((menu) => {
      return (
        <ul key={menu.id} className={"space-y-5"}>
          <li>
            <h2 className={"text-sm font-semibold uppercase leading-4"}>{menu.name}</h2>
          </li>
          {menu.links.map((link) => {
            return (
              <li key={link.id}>
                <Link
                  to={link.link}
                  title={link.name}
                  className={"responsive-transition leading-6 text-on-surface hover:text-on-primary"}
                >
                  {link.name}
                </Link>
              </li>
            );
          })}
          {menu.id === 2 ? (
            <li>
              <Link
                to={ROUTES.MAIN.GENRES}
                className={"responsive-transition uppercase leading-6 text-on-surface underline hover:text-on-primary"}
              >
                {t("General.more")}
              </Link>
            </li>
          ) : null}
        </ul>
      );
    })}
  </div> */
}
